import ServicesInstance from 'modules/services/repository';

export const getServices = (startup, page, size, search, filters, sort) => ServicesInstance.getActiveServices({
  startup, page, size, search, filters, sort,
});

export const createServicesRequest = (data) => ServicesInstance.createServicesRequest(data);

export const deleteServicesRequest = (id) => ServicesInstance.deleteServicesRequest(id);
